import React from "react";
import { Card, CardActionArea, CardMedia, Tooltip, Typography } from "@mui/material"
import { ALBUM_COVER_SIZE, ALBUM_DETAILS_WIDTH } from "../../utils/constants/viewConstants";

const DetailedAlbumItem = ({album, onClick}) => {
    const imageSize = ALBUM_COVER_SIZE;
    const contentWidth = ALBUM_DETAILS_WIDTH;

    return (
        <Card>
            <Tooltip title={`${album.name} · ${album.artist}`} followCursor={true} >
                <CardActionArea onClick={onClick} onContextMenu={onClick}>
                    <div className="d-flex flex-row">
                        <CardMedia image={album.images.md.url} sx={{ minWidth: imageSize, height: imageSize }} />
                        <div className="d-flex flex-column jc-center gap-1 p-0_5" style={{ minWidth: contentWidth }}>
                            <Typography noWrap>{album.name}</Typography>
                            <Typography noWrap>{album.artist}</Typography>
                        </div>
                    </div>
                </CardActionArea>
            </Tooltip>
        </Card>
    )
}

export default DetailedAlbumItem;